import { useLocalStorage } from '@sortlist-frontend/utils';

import { Page } from '_types/public-api';

export function useDirectBriefingData({ page }: { page: Page }) {
  const [, setValue] = useLocalStorage('directBriefingDataKey', {});

  /**
   * This will set data that we use later when opening a directBriefing on the agency profile page
   */
  const setDirectBriefingDataKey = () => {
    const { location: dbLocation, expertise } = page?.data?.attributes.briefing_options || {};
    const location = { ...dbLocation, placeId: dbLocation?.place_id };

    setValue(JSON.stringify({ location, expertise }));
  };

  return { setDirectBriefingDataKey };
}
